jQuery(function ($) {
	'use strict';

	/**
	 * モバイルかどうかを返す
	 *
	 * @returns {boolean}
	 */
	function isMobile() {
		'use strict';

		var mobileFlag = false;

		if (navigator.userAgent.indexOf('iPhone') > 0 ||
			navigator.userAgent.indexOf('iPad') > 0 ||
			navigator.userAgent.indexOf('iPod') > 0 ||
			navigator.userAgent.indexOf('Android') > 0) {
			mobileFlag = true;
		}
		return mobileFlag;
	}

	if (!isMobile()) {
		$('.js-tel').replaceWith(function () {
			$(this).replaceWith(`<span>${$(this).text()}</span>`);
		});
	}

});
